/* eslint-disable dot-notation, quote-props */
import queryString from 'query-string';

export default async function request(method, path, params = {}) {
  const {
    query,
    data,
    headers: customHeaders,
  } = params;

  const {
    clientApiToken,
    baseUri,
    headers: configHeaders,
    fetch,
    AbortController,
    requestTimeoutMs,
  } = this.config;

  const headers = {
    'Magine-AccessToken': clientApiToken,
    'Accept': 'application/json',
  };

  if (this.authData) {
    headers['Authorization'] = `Bearer ${this.authData.token}`;
  }

  if (data) {
    headers['Content-Type'] = 'application/json';
  }

  const search = queryString.stringify(query);
  const url = baseUri + path + (search ? `?${search}` : '');

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), requestTimeoutMs);

  const response = await fetch(url, {
    signal: controller.signal,
    method,
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      ...headers,
      ...configHeaders,
      ...customHeaders,
    },
    body: data ? JSON.stringify(data) : null,
  }).finally(() => clearTimeout(timeout));

  const isJSON = (response.headers.get('Content-Type') || '').includes('application/json');

  return {
    status: response.status,
    body: await (isJSON ? response.json() : response.text()),
  };
}
